import {
    Button,
    Card,
    CardActions,
    CardContent,
    Grid,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import { Sync } from "@mui/icons-material";
import { HttpStatusCode } from "axios";
import * as React from "react";
import AuthContext from "../../../route/AuthContext";
import ParameterService from "../../../services/ParameterService";
import CustomSweetalert from "../../../theme/sweetalert";

const InnovationPlazaSetting = () => {
    const authContext = React.useContext(AuthContext);
    const [lastSync, setLastSync] = React.useState<string>('');
    const [editedLastSync, setEditedLastSync] = React.useState<string>('');
    const [saving, setSaving] = React.useState(false);
    const [syncing, setSyncing] = React.useState(false);

    const loadData = async () => {
        const [status, response] = await ParameterService.getInnovationPlazaParameters(authContext);
        if (status === HttpStatusCode.Ok && response?.lastSync) {
            setLastSync(response.lastSync);
            setEditedLastSync(response.lastSync);
        }
    };

    React.useEffect(() => { loadData(); }, []);

    const handleSaveWatermark = async () => {
        setSaving(true);
        const [status] = await ParameterService.saveInnovationPlazaWatermark(authContext, editedLastSync);
        setSaving(false);
        if (status === HttpStatusCode.Ok) {
            CustomSweetalert({ title: 'Completato', text: 'Data ultimo allineamento aggiornata.', icon: 'success' })
                .then(loadData);
        } else {
            CustomSweetalert({ title: 'Errore', text: 'Si è verificato un errore durante il salvataggio.', icon: 'error' });
        }
    };

    const handleSync = async () => {
        const confirm = await CustomSweetalert({
            title: 'Avvia sincronizzazione?',
            text: 'Verrà avviata una sincronizzazione manuale con Innovation Plaza. Il processo può richiedere alcuni minuti.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Avvia',
            cancelButtonText: 'Annulla',
            reverseButtons: true,
        });
        if (!confirm.isConfirmed) return;

        setSyncing(true);
        const [status] = await ParameterService.triggerInnovationPlazaSync(authContext);
        setSyncing(false);
        if (status === HttpStatusCode.Ok || status === 202) {
            CustomSweetalert({
                title: 'Sincronizzazione avviata',
                text: 'Il processo è in esecuzione in background. La data di ultimo allineamento verrà aggiornata al termine.',
                icon: 'info'
            }).then(loadData);
        } else {
            CustomSweetalert({ title: 'Errore', text: 'Non è stato possibile avviare la sincronizzazione.', icon: 'error' });
        }
    };

    return (
        <Card sx={{ width: '100%', mt: 2, mb: 2 }}>
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="h5">Innovation Plaza — Sincronizzazione</Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Data ultimo allineamento"
                            type="date"
                            value={editedLastSync}
                            onChange={e => setEditedLastSync(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            helperText={lastSync ? `Valore corrente: ${lastSync}` : 'Nessun allineamento registrato'}
                            disabled={saving || syncing}
                        />
                    </Grid>
                </Grid>
            </CardContent>
            <CardActions>
                <Stack direction="row" spacing={1} justifyContent="flex-end" flex={1}>
                    <Button
                        variant="outlined"
                        color="secondary"
                        startIcon={<Sync />}
                        onClick={handleSync}
                        disabled={saving || syncing}
                    >
                        {syncing ? 'Avvio in corso...' : 'Forza sincronizzazione'}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSaveWatermark}
                        disabled={saving || syncing || !editedLastSync}
                    >
                        {saving ? 'Salvataggio...' : 'Salva data'}
                    </Button>
                </Stack>
            </CardActions>
        </Card>
    );
};

export default InnovationPlazaSetting;
